import Vue from "vue"
import { base64Decode, clientKeyMap } from "@/utils/utils"

/**
 * 懒初始化 $sdk，确保在 bootstrapData 执行完毕后再构造
 * bootstrapData 会将 commData 写入 localStorage，此时才能正确读取 commonReqParams
 */
const getSdkInstance = () => {
  if (Vue.prototype._sdk && Vue.prototype._sdk instanceof PaymentSDK) {
    return Vue.prototype._sdk
  }

  if (!process.client || typeof PaymentSDK === "undefined") {
    return null
  }

  const commData = localStorage.getItem("commData")
  const { commonReqParams } = commData ? JSON.parse(commData) : {}
  const accountInfo = localStorage.getItem("accountInfo") ? base64Decode(localStorage.getItem("accountInfo")) : ""

  const sdk = new PaymentSDK({
    baseURL: process.env.VUE_APP_PAYMENTHUB_API,
    headers: {},
    merchantId: commonReqParams ? commonReqParams.venderId : "",
    merchantUserId: accountInfo.custId,
    clientKey: clientKeyMap[commonReqParams.venderId],
    lang: commonReqParams ? commonReqParams["superweb-locale"] : ""
  })

  Vue.prototype._sdk = sdk
  return sdk
}

// 覆盖 Vue.prototype.$sdk 的 get 操作，在首次访问时懒初始化
Object.defineProperty(Vue.prototype, "$sdk", {
  get() {
    return getSdkInstance()
  },
  configurable: true
})

// bootstrapData 执行完毕后，同步更新语言（如果 $sdk 已初始化）
window.onNuxtReady(nuxt => {
  const lang = nuxt.$cookies.get("superweb-locale") || ""
  if (lang && Vue.prototype._sdk && typeof Vue.prototype._sdk.updateLang === "function") {
    Vue.prototype._sdk.updateLang(lang)
  }
})
